import { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { marketingApi } from '../api/marketing'
import Boton from '../components/Boton'

const EMPTY = {
  nombre: '', asunto: '', preheader: '', lista_id: '', plantilla_id: '',
  cuerpo_html: '', remitente_nombre: '', remitente_email: '', programada_at: '',
}

export default function MktCampanaFormPage() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [form, setForm] = useState(EMPTY)
  const [listas, setListas] = useState([])
  const [plantillas, setPlantillas] = useState([])
  const [guardando, setGuardando] = useState(false)
  const [err, setErr] = useState('')
  const [tab, setTab] = useState('editar') // editar | preview

  useEffect(() => {
    marketingApi.listas().then(r => setListas(r.data))
    marketingApi.plantillas().then(r => setPlantillas(r.data))
    if (id) {
      marketingApi.campana(id).then(r => {
        const c = r.data
        setForm({
          nombre: c.nombre || '', asunto: c.asunto || '', preheader: c.preheader || '',
          lista_id: c.lista_id || '', plantilla_id: c.plantilla_id || '',
          cuerpo_html: c.cuerpo_html || '', remitente_nombre: c.remitente_nombre || '',
          remitente_email: c.remitente_email || '',
          programada_at: c.programada_at ? c.programada_at.substring(0, 16) : '',
        })
      })
    }
  }, [id])

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }))

  // Al elegir plantilla sin cuerpo propio, copiar el HTML como punto de partida
  const elegirPlantilla = async (pid) => {
    set('plantilla_id', pid)
    if (pid && !form.cuerpo_html) {
      const r = await marketingApi.plantilla(pid)
      setForm(f => ({ ...f, plantilla_id: pid, cuerpo_html: r.data.cuerpo_html, asunto: f.asunto || r.data.asunto || '' }))
    }
  }

  const guardar = async (e) => {
    e.preventDefault(); setGuardando(true); setErr('')
    const payload = {
      ...form,
      lista_id: form.lista_id || null,
      plantilla_id: form.plantilla_id || null,
      programada_at: form.programada_at || null,
    }
    try {
      if (id) {
        await marketingApi.actualizarCampana(id, payload)
        navigate(`/marketing/campanas/${id}`)
      } else {
        const r = await marketingApi.crearCampana(payload)
        navigate(`/marketing/campanas/${r.data.id}`)
      }
    } catch (error) {
      setErr(error.response?.data?.message || 'Error al guardar')
      setGuardando(false)
    }
  }

  return (
    <div style={{ maxWidth: 980 }}>
      <Boton variante="ghost" sm style={{ marginBottom: 8 }} onClick={() => navigate(-1)}>← Volver</Boton>
      <h2 style={st.title}>{id ? 'Editar campaña' : 'Nueva campaña'}</h2>

      <form onSubmit={guardar}>
        <div style={st.grid}>
          <div>
            <label style={st.lbl}>Nombre interno *</label>
            <input style={st.inp} value={form.nombre} onChange={e => set('nombre', e.target.value)} required placeholder="Promo vinos junio" />
          </div>
          <div>
            <label style={st.lbl}>Lista / segmento *</label>
            <select style={st.inp} value={form.lista_id} onChange={e => set('lista_id', e.target.value)}>
              <option value="">— Elegir —</option>
              {listas.map(l => <option key={l.id} value={l.id}>{l.nombre} ({l.aptos_envio} aptos)</option>)}
            </select>
          </div>
          <div>
            <label style={st.lbl}>Asunto *</label>
            <input style={st.inp} value={form.asunto} onChange={e => set('asunto', e.target.value)} required placeholder="🍷 Llegaron los tintos de guarda" />
          </div>
          <div>
            <label style={st.lbl}>Preheader</label>
            <input style={st.inp} value={form.preheader} onChange={e => set('preheader', e.target.value)} placeholder="Texto gris junto al asunto" />
          </div>
          <div>
            <label style={st.lbl}>Plantilla base</label>
            <select style={st.inp} value={form.plantilla_id} onChange={e => elegirPlantilla(e.target.value)}>
              <option value="">— Sin plantilla (HTML propio) —</option>
              {plantillas.map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}
            </select>
          </div>
          <div>
            <label style={st.lbl}>Programar para (opcional)</label>
            <input style={st.inp} type="datetime-local" value={form.programada_at} onChange={e => set('programada_at', e.target.value)} />
          </div>
          <div>
            <label style={st.lbl}>Remitente — nombre</label>
            <input style={st.inp} value={form.remitente_nombre} onChange={e => set('remitente_nombre', e.target.value)} placeholder="Vinoteca Ligier" />
          </div>
          <div>
            <label style={st.lbl}>Remitente — email</label>
            <input style={st.inp} type="email" value={form.remitente_email} onChange={e => set('remitente_email', e.target.value)} placeholder="news@vinotecaligier.com" />
          </div>
        </div>

        <div style={st.tabs}>
          <button type="button" onClick={() => setTab('editar')} style={{ ...st.tabBtn, ...(tab === 'editar' ? st.tabOn : {}) }}>✏️ HTML</button>
          <button type="button" onClick={() => setTab('preview')} style={{ ...st.tabBtn, ...(tab === 'preview' ? st.tabOn : {}) }}>👁 Preview</button>
          <span style={st.vars}>Variables: {'{{ nombre }} · {{ email }} · {{ unsubscribe_url }}'}</span>
        </div>

        {tab === 'editar' ? (
          <textarea style={st.editor} value={form.cuerpo_html} onChange={e => set('cuerpo_html', e.target.value)}
            placeholder="<html>… o elegí una plantilla base arriba" spellCheck={false} />
        ) : (
          <iframe title="preview" style={st.preview} srcDoc={
            (form.cuerpo_html || '<p style="font-family:sans-serif;color:#888;padding:24px">(sin contenido)</p>')
              .replace(/\{\{\s*nombre\s*\}\}/gi, 'Juan Prueba')
              .replace(/\{\{\s*email\s*\}\}/gi, 'prueba@lgr.local')
              .replace(/\{\{\s*unsubscribe_url\s*\}\}/gi, '#')
          } />
        )}

        {err && <p style={st.error}>{err}</p>}
        <div style={st.actions}>
          <Boton variante="ghost" type="button" onClick={() => navigate(-1)}>Cancelar</Boton>
          <Boton variante="primary" type="submit" disabled={guardando}>{guardando ? 'Guardando…' : 'Guardar borrador'}</Boton>
        </div>
      </form>
    </div>
  )
}

const st = {
  title: { margin: '0 0 16px', fontSize: '1.4rem', color: '#0f172a' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 16 },
  lbl: { display: 'block', fontWeight: 600, fontSize: '0.85rem', color: '#374151', marginBottom: 4 },
  inp: { width: '100%', padding: '0.55rem 0.75rem', border: '1px solid #d1d5db', borderRadius: 8, fontSize: '0.92rem', boxSizing: 'border-box', background: '#fff' },
  tabs: { display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 },
  tabBtn: { padding: '0.45rem 0.9rem', border: '1px solid #d1d5db', borderRadius: 8, background: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: '0.85rem' },
  tabOn: { background: '#1e40af', color: '#fff', borderColor: '#1e40af' },
  vars: { marginLeft: 'auto', fontSize: '0.75rem', color: '#94a3b8', fontFamily: 'monospace' },
  editor: { width: '100%', height: 380, fontFamily: 'monospace', fontSize: '0.82rem', padding: 12, border: '1px solid #d1d5db', borderRadius: 10, boxSizing: 'border-box', resize: 'vertical' },
  preview: { width: '100%', height: 380, border: '1px solid #d1d5db', borderRadius: 10, background: '#fff' },
  error: { color: '#dc2626', fontSize: '0.875rem' },
  actions: { display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 14 },
}
